import type { IStepperStep } from "@front-shared/types/objects.types.ts"

import { ClientDataStep } from "../components/intakeDemo/steps/clientData.step.tsx"
import { InsuranceDataStep } from "../components/intakeDemo/steps/insuranceData.step.tsx"
import { ReasonStep } from "../components/intakeDemo/steps/reason.step.tsx"

export const STEPPER_CONFIG = {
    intakeDemoInitial: [
        {
            key: "reasonData",
            stepComponent: ReasonStep,
        },
        {
            key: "clientData",
            stepComponent: ClientDataStep,
        },
    ] as IStepperStep[],

    intakeDemoPayer: [
        {
            key: "insuranceData",
            stepComponent: InsuranceDataStep,
        },
    ] as IStepperStep[],
}
